import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { showToast } from '../../../actions/Actions.js';
import Select from '../../components/Select.js';
import Spinner from '../../components/Spinner.js';
import '../../../css/CommonTheme.css';
import '../../../css/AccountSettings.css';
import { addQbClass, selectQbClass } from '../../../actions/QbClassActions.js';
import { createNewQbClass } from '../../../requests/QbClassRequests.js';

const qbClassFields = ['id', 'name', 'active', 'account_id'];

class NewQbClassForm extends Component {
    constructor(props) {
        super(props);
        this.state = this.defaultState();
    }

    defaultState = () => {
        const { accountId } = this.props;
        return {
            nameInvalidMsg: '',
            name: '',
            active: 'Yes',
            account_id: accountId,
            spinner_loader: false,
        };
    };

    constructQbClass = () => {
        const data = {};
        qbClassFields.forEach(field => {
            if (field in this.state) {
                data[field] = this.state[field];
            }
        });
        return data;
    };

    checkRequiredFields = () => {
        const { name } = this.state;
        if (name === '') {
            this.props.showToast('Please fill out the class name', 'warning');
            return false;
        }
        return true;
    };

    saveQbClass = async event => {
        event.preventDefault();
        if (this.state.nameInvalidMsg !== '') {
            this.props.showToast('Please fix the form errors before submitting', 'warning');
            return;
        }

        if (!this.checkRequiredFields()) {
            return;
        }

        this.setState({ spinner_loader: true });

        try {
            const qbClass = this.constructQbClass();
            const apiData = {
                'QuickbooksClass[name]': qbClass.name,
                'QuickbooksClass[account_id]': qbClass.account_id,
            };

            const result = await createNewQbClass(apiData);
            this.props.addQbClass(result);
            this.props.showToast('QB Class created successfully', 'success');

            setTimeout(() => {
                this.setState({ spinner_loader: false });
                this.props.history.push('/resource_settings/classes');
            }, 1000);
        } catch (error) {
            console.error('Error creating QB Class:', error);
            this.props.showToast('Failed to create QB Class. Please try again.', 'error');
            this.setState({ spinner_loader: false });
        }
    };

    handleNameChanged = event => {
        const name = event.target.value;
        this.setState({ name });
        if (name === '') {
            this.setState({ nameInvalidMsg: 'Class name is required' });
        } else {
            this.setState({ nameInvalidMsg: '' });
        }
    };

    handleActiveChanged = value => {
        this.setState({ active: value });
    };

    render() {
        const { name, active, nameInvalidMsg, spinner_loader } = this.state;

        const activeOptions = [{ name: 'Active', id: 'Yes' }, { name: 'Inactive', id: 'No' }];

        return (
            <div className="applicationWrapper">
                <div className="applicationBody">
                    <div className="bodyHeader">
                        <h2>Create New QB Class</h2>
                    </div>
                    <div className="accountSettingsContainer">
                        <form onSubmit={this.saveQbClass}>
                            <Row>
                                <Col md={6}>
                                    <div className="stackedLabelAndInput fieldGroup">
                                        <label className="inputLabel">Class Name *</label>
                                        <Input
                                            type="text"
                                            value={name}
                                            onChange={this.handleNameChanged}
                                            className={nameInvalidMsg ? 'invalidInput' : ''}
                                            placeholder="Enter class name"
                                        />
                                        {nameInvalidMsg && (
                                            <div className="invalidInputMsg">{nameInvalidMsg}</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="fieldGroup">
                                        <button
                                            type="submit"
                                            className="primaryButton"
                                            disabled={spinner_loader}
                                        >
                                            {spinner_loader ? <Spinner /> : 'Create QB Class'}
                                        </button>
                                        <button
                                            type="button"
                                            className="secondaryButton"
                                            onClick={() =>
                                                this.props.history.push(
                                                    '/resource_settings/classes'
                                                )
                                            }
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        accountId: state.accountStore.id,
    };
}

const mapDispatchToProps = {
    showToast,
    addQbClass,
    selectQbClass,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewQbClassForm);
